import React, { PureComponent } from "react";
import { cloud } from "@vitalsource/vstui/colors";
import { Icon } from "@vitalsource/vstui";

class PrintRangeIcon extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={18} width={24}>
        <path
          d="M21.995 13h-3.997v-3h-12v3H2V7h19.995v6zM7.998 16v-4h8v1h-.003v3H7.998zm0-11h8V2h-8v3zm13.997 0h-3.997V1a1 1 0 00-1-1h-10a1 1 0 00-1 1v4H2C.9 5 0 5.9 0 7v6c0 1.1.9 2 2 2h3.998v2a1 1 0 001 1h10a1 1 0 001-1v-2h3.997c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"
          fill={cloud.getShade(5)}
          fillRule="evenodd"
        />
      </Icon>
    );
  }
}

PrintRangeIcon.displayName = "PrintRangeIcon";
PrintRangeIcon.vstuiName = "Icon";

export default PrintRangeIcon;
